import { useQuery } from "@tanstack/react-query";
import { ApiGetUserInviteTeam } from "@/api";

/**
 * 拉取当前用户邀请团队成员数据。
 * @param coinContract 代币合约地址，与后端 `GetUserInviteTeamRequest.coinContract` 一致
 */
export function useUserInviteTeam(coinContract: string | undefined) {
  return useQuery({
    queryKey: ["userInviteTeam", coinContract ?? ""],
    queryFn: async () => {
      if (!coinContract) {
        throw new Error("useUserInviteTeam: coinContract is required");
      }
      const res = await ApiGetUserInviteTeam({ coinContract });
      console.log("useUserInviteTeam", res.data);
      return res.data;
    },
    enabled: Boolean(coinContract),
  });
}
